export default "__VITE_ASSET__8ef1b929__"